import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { contentAi } from '@mi-front/api-clients';
import { Alert, Button } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { FormattedMessage } from 'react-intl';
import { pushTo } from '../../../../../../core/routing';

interface Props {
  id: string;
}

export function CreateFragmentContent({ id }: Props) {
  const mutation = contentAi.useContentCreate();

  return (
    <IfPermission
      permission={contentAi.contentAiPermissions.Contents_Create}
      cant={() => (
        <Alert severity="warning">
          <FormattedMessage
            id="fragments.contentAi.noPermission"
            defaultMessage="No tienes permisos para crear contenido"
          />
        </Alert>
      )}
    >
      <Button
        size={'large'}
        color="primary"
        variant="outlined"
        onClick={async () => {
          mutation.mutate(
            {
              data: {
                sourceType: 'FRAGMENT',
                sourceData: {
                  fragmentId: id,
                },
                key: `FRAGMENT:${id}`,
              },
            },
            {
              onSuccess: (data) => {
                pushTo(`/content-ai/contents/${data.id}`);
              },
            },
          );
        }}
        loading={mutation.isPending || mutation.isSuccess}
        startIcon={<AutoAwesomeIcon />}
      >
        <FormattedMessage
          id="fragments.contentAi.generateFromFragment"
          defaultMessage="Generar contenido a partir de este fragmento"
        />
      </Button>
    </IfPermission>
  );
}
